import React from 'react';
import { Link } from 'react-router-dom';
import { SurveyResponse } from '../../types';
import { testerLabel } from '../../utils/tester';

const ROLE_LABELS: Record<string, string> = {
  customer: 'Customer',
  support: 'Support',
  technician: 'Technician',
  factory: 'Factory',
  developer: 'Developer',
  admin: 'Admin',
};

const platformLabel = (platform?: string) => {
  if (platform === 'ios') return 'iOS';
  if (platform === 'android') return 'Android';
  return platform || '';
};

const accountName = (result: SurveyResponse) => {
  const previewName = result.userPreview?.name?.trim();
  if (previewName) return previewName;
  const name = [result.account?.firstName, result.account?.lastName].filter(Boolean).join(' ').trim();
  return name || result.account?.email || 'Not logged in';
};

interface SurveyUserHoverProps {
  result: SurveyResponse;
  onClick?: (event: React.MouseEvent) => void;
}

const SurveyUserHover: React.FC<SurveyUserHoverProps> = ({ result, onClick }) => {
  const name = accountName(result);
  const userId = result.account?.userId;
  const preview = result.userPreview;
  const email = preview?.email || result.account?.email || '—';
  const role = preview?.role ? (ROLE_LABELS[preview.role] || preview.role) : '—';
  const testingGroup = preview?.tester ? testerLabel(preview.tester as 'none' | 'internal' | 'beta') : '—';
  const phones = preview?.phones || [];

  const label = userId ? (
    <Link to={`/users/${userId}`} onClick={onClick}>
      {name}
    </Link>
  ) : (
    <span>{name}</span>
  );

  return (
    <span className="survey-user-tip">
      {label}
      <span className="survey-user-tip-card" role="tooltip">
        <strong className="survey-user-tip-name">{name}</strong>
        <span>
          <b>Email</b>
          {email}
        </span>
        <span>
          <b>User type</b>
          {role}
        </span>
        <span>
          <b>Testing group</b>
          {testingGroup}
        </span>
        <span>
          <b>Phones</b>
          {phones.length ? (
            <ul className="survey-user-tip-phones">
              {phones.map((phone) => (
                <li key={`${phone.name}-${phone.platform}`}>
                  {phone.name}{phone.platform ? ` (${platformLabel(phone.platform)})` : ''}
                </li>
              ))}
            </ul>
          ) : (
            'None'
          )}
        </span>
      </span>
    </span>
  );
};

export default SurveyUserHover;
